import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { Global } from '../../global';
import { DariCalendarService } from '../../../services/DariCalendar';
import { MatSnackBar, MatDatepickerInputEvent, MatDialog } from '@angular/material';
import { Expense_Service } from '../../../services/Acc_Expense_Service';
import { ExcelService } from '../../../services/ExcelService';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import * as moment from 'jalali-moment';
import { EditExpenseDialogComponent } from '../edit-expense-dialog/edit-expense-dialog.component';
import { Txn_Expense } from '../../../models/Txn_Expense';
import { log } from 'util';
import { EditExpenseStatusDialogComponent } from '../edit-expense-status-dialog/edit-expense-status-dialog.component';
import { DashboardService } from '../../../services/dashboard.service';
import { UserDetails } from '../../../models/userDetails.interface';
import * as $ from 'jquery';
import { forEach } from '@angular/router/src/utils/collection';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-expense-list',
  templateUrl: './expense-list.component.html',
  styleUrls: ['./expense-list.component.css']
})
export class ExpenseListComponent implements OnInit {
  ArrLabels: any;
  labels: any = {};
  expenseList: any;
  expenseAccounts: any;
  fromDate: string;
  toDate: string;
  fromDateFa: string;
  toDateFa: string;
  statusId: number;
  selectedAccountNumber: string = 'all';
  selectedAccountName: string;
  myControl = new FormControl();
  GL_Masters: any;
  selectedGL_Master: string = 'all';
  selectedGL_Child: string = 'all';
  typeId: number = 0;
  branchId: number = 0;
  GL_Childs: any;
  recordCount: number;
  amount_sum: number = 0;
  amount_sum_accept: number = 0;
  amount_sum_reject: number = 0;

  constructor(
    public dialog: MatDialog,
    private UtilityService: UtilityService,
    private global: Global,
    private DariCalendar: DariCalendarService,
    private snackBar: MatSnackBar,
    private expenseService: Expense_Service,
    private GL_MasterService: GL_MasterService,
    private excelService: ExcelService,
    private userDetailService: DashboardService
  ) {
    this.getBranchId();
    this.getExpenses();
  }

  userName: string = "";
  ngOnInit() {
    this.getLabels();
    this.getGlMasters();

    this.userDetailService.getUserDetails()
      .subscribe((userDetails: UserDetails) => {
        //this.userDetails = userDetails;
        //this.email = userDetails.email;
        this.userName = userDetails.userName;
      },
        error => {
          console.log(error);
          //this.notificationService.printErrorMessage(error);
        });
  }
  isBranchId: number = -1;
  userId: string = '0';
  getBranchId() {
     
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/expense-list")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
      this.userId = dataAccessUrl.userId
    }
  }


  checkViewEditDelete(statusId, uId) {
    if (uId == this.userId && statusId == 1)
      return true;
    return false;
  }

  checkViewStatus(statusId, uId) {
    if (this.userName.toLowerCase() != "admin@admin.com") {
      //this.openSnackBarInfo("شما به این بخش دسترسی ندارید", '');
      return false;
    }
    return true;
  }

  getGlMasters() {

    this.GL_MasterService.getGL_Masters("Expenses", this.isBranchId)
      .subscribe(response => {
        if (response) {
          this.GL_Masters = response;
        }
      },
        error => console.log("error --> " + error))

  }

  getGlChilds() {
    this.GL_MasterService.getGL_Childs(this.selectedGL_Master, this.branchId)
      .subscribe(response => {
        if (response) {
          this.GL_Childs = response;
        }
      },
        error => console.log("error --> " + error))

  }



  getExpenses() {
    this.expenseService.getExpenses(this.selectedGL_Master, this.selectedGL_Child, this.fromDate, this.toDate, this.statusId, this.typeId, this.branchId, this.userId)
      .subscribe(response => {
        this.expenseList = response;
        console.log(this.expenseList);
        this.recordCount = this.expenseList.length;
        this.amount_sum = 0;
        this.amount_sum_accept = 0;
        this.amount_sum_reject = 0;

        let currentValue = 0;
        for (let exp in this.expenseList) {
          currentValue = this.expenseList[exp].expense_amount;
          this.amount_sum += currentValue;

          if (this.expenseList[exp].statusId == 2)
            this.amount_sum_accept += currentValue;

          if (this.expenseList[exp].statusId == 3)
            this.amount_sum_reject += currentValue;

          if (this.expenseList[exp].value_date) {
            this.expenseList[exp].value_date_da = this.DariCalendar.PersianCalendar(new Date(this.expenseList[exp].value_date));
          }
        }
      });
  }
  FromDateChanged(event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    this.fromDateFa = _pdate;
    var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
    this.fromDate = _date;
    //this.fromDate_DariDate = _pdate;
  }
  ToDateChanged(event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    this.toDateFa = _pdate;
    var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
    this.toDate = _date;
  }


  //exportAsXLSX(): void {
  //  this.excelService.exportAsExcelFile(this.expenseList, 'ExpenseList');
  //}

  @ViewChild('tableReport') table: ElementRef;
  exportAsXLSX(): void {
    //this.excelService.exportAsExcelFile(this.invoiceList, 'invoiceList');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'expenseList.xlsx');
  }


  deleteExpense(trn_ref_no: string, statusId: number, userId: number) {

    //if (this.checkViewEditDelete(statusId, userId) == false) {
    //  this.openSnackBarInfo("شما نمی توانید این رکورد را حذف کنید", '');
    //  return;
    //}


    if (!confirm("تایید؟"))
      return;

    this.expenseService.deleteExpense(trn_ref_no).subscribe(
      response => {
        if (response == 'success') {
          this.openSnackBarInfo('رکورد مورد نظر حذف شد', '')
          var exForDelete = this.expenseList.find((o: any) => o.trn_ref_no === trn_ref_no);
          this.expenseList.splice(this.expenseList.indexOf(exForDelete), 1);
        }
        else {
          console.log(response);
          this.openSnackBarInfo('خطا در حذف مصارف', '')
        }
      }
    )
  }

  updatePrintExpence(trn_ref_no: string): void {

    let data: any = {
      trn_ref_no: trn_ref_no,
      id: 0,
    };
    let exp: Txn_Expense = data;
    this.expenseService.updatePrintExpense(exp).subscribe(response => {
      console.log(response);
      if (response == 'Success') {
        this.getExpenses();
        this.openSnackBarInfo('پرینت شد', '')
      }
      else
        this.openSnackBarInfo('خطا در پرینت', '')
    });
  }

  openDialog(trn_ref_no: string, value_date: Date, expense_remark: string, statusId: number, userId: number): void {

    if (this.checkViewEditDelete(statusId, userId) == false) {
      this.openSnackBarInfo("شما نمی توانید این رکورد را ویرایش کنید", '');
      return;
    }

     
    const dialogRef = this.dialog.open(EditExpenseDialogComponent, {
      width: '250px',
      backdropClass: 'custom-dialog-backdrop-class',
      panelClass: 'custom-dialog-panel-class',
      data: { trn_ref_no: trn_ref_no, value_date: value_date, expense_remark: expense_remark }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('after dialog close...')
      if (result) {
        console.log('inside update...')
        console.log(result.data);
        var exp: Txn_Expense = result.data;
        var _pdate = moment(exp.value_date).format('jYYYY-jMM-jDD');
        var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
        exp.value_date = new Date(_date);
        this.expenseService.updateExpense(exp).subscribe(response => {
          console.log(response);
          if (response == 'Success') {
            this.getExpenses();
            this.openSnackBarInfo('آپدیت شد', '')
          }
          else
            this.openSnackBarInfo('خطا در آپدیت', '')
        });
      }
    });
  }

  openStatusDialog(trn_ref_no: string, value_date: Date, expense_remark: string, id: number, statusId: number, userId: number): void {

    if (this.userName.toLowerCase() != "admin@admin.com") {
      this.openSnackBarInfo("شما به این بخش دسترسی ندارید", '');
      return;
    }

     
    const dialogRef = this.dialog.open(EditExpenseStatusDialogComponent, {
      width: '250px',
      backdropClass: 'custom-dialog-backdrop-class',
      panelClass: 'custom-dialog-panel-class',
      data: {
        statusId: statusId,
        trn_ref_no: trn_ref_no,
        value_date: value_date,
        expense_remark: expense_remark,
        id: id,
      }
    });

     
    dialogRef.afterClosed().subscribe(result => {
      console.log('after dialog close...')
      if (result) {
        console.log('inside update...')
        console.log(result.data);
        var exp: Txn_Expense = result.data;
        //exp.statusId = exp.statusId;
        this.expenseService.updateStatusExpense(exp).subscribe(response => {
          console.log(response);
          if (response == 'Success') {
            this.getExpenses();
            this.openSnackBarInfo('آپدیت شد', '')
          }
          else
            this.openSnackBarInfo('خطا در آپدیت', '')
        });
      }
    });
  }

  openSnackBarInfo(message: string, action: string) {
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 2000,
    });
    snackBarRef.closeWithAction = function () {
      snackBarRef.dismiss();
    }
  }



  printVariables: any = {}
  printDialog(value) {

    if (value.isPrint == true) {
      this.openSnackBarInfo('امکان پرینت مجدد وجود ندارد', '');
      return;
    }

    if (value) {
       
      this.printVariables['exp_date'] = this.DariCalendar.PersianCalendar(new Date(value.value_date));
      this.printVariables['exp_id'] = value.id;
      this.printVariables['exp_DR'] = value.expense_GL_DR;
      this.printVariables['exp_CR'] = value.expense_GL_CR;
      this.printVariables['exp_DR_Code'] = value.gL_DR;
      this.printVariables['exp_CR_Code'] = value.gL_CR;
      this.printVariables['exp_branch'] = value.branchTitle;
      this.printVariables['exp_amount'] = value.expense_amount;
      this.printVariables['exp_docid'] = value.documentNo;
      this.printVariables['exp_desc'] = value.expense_remark;


      let that = this;
      setTimeout(() => {
        var content = $("#print-section").prop('outerHTML');
        var printWindow = window.open('', '', '');
        printWindow.document.write('<html><head><title>Print</title>');
        var _link = $('link');
        var _style = $('style');
        var strstyle = '';
        var _script = $('script');
        for (var k = 0; k < _link.length; k++)
          printWindow.document.write(_link[k].outerHTML);
        for (var i = 0; i < _style.length; i++)
          printWindow.document.write(_style[i].outerHTML);
        for (var j = 0; j < _script.length; j++)
          printWindow.document.write(_script[j].outerHTML);
        printWindow.document.write('</head><body  style="-webkit-print-color-adjust: exact;     margin-top: 1px;"  >');
        printWindow.document.write(content);
        printWindow.document.write('<script> $(".AES").css("display", "block");</script> </body ></html>');
        printWindow.document.close();

        this.updatePrintExpence(value.trn_ref_no);

      }, 1000)
    }
  }

  reportData: any[] = [];
  printDialogAccount() {

    if (this.selectedGL_Child == undefined || this.selectedGL_Child == null || this.selectedGL_Child == "all") {
      this.openSnackBarInfo('لطفا اکانت فرعی را انتخاب نمایید  و جستجو را انجام دهید.', '');
      return;
    }

    this.printVariables['AccountName'] = this.GL_Childs.find(f => f.gL_ChildCode == this.selectedGL_Child).gL_ChildDesc
    this.printVariables['AccountNumber'] = this.selectedGL_Child;

    let balance = 0;
    let expense_amount_DR = 0;
    let expense_amount_CR = 0;
    let valueDateEN: string = "";
    for (let i = 0; i < this.expenseList.length; i++) {
      if (this.selectedGL_Child == this.expenseList[i].DR_GL_Code) {
        expense_amount_DR = this.expenseList[i].expense_amount;
        balance -= expense_amount_DR;
      } else {
        expense_amount_CR = this.expenseList[i].expense_amount;
        balance += expense_amount_CR;
      }
      valueDateEN = moment.from(this.expenseList[i].value_date_da, 'fa').format('YYYY-MM-DD');
      this.reportData.push(
        {
          date: this.expenseList[i].value_date_da + ' - ' + valueDateEN,
          documentNo: this.expenseList[i].documentNo,
          expense_remark: this.expenseList[i].expense_remark,
          expense_amount_DR: expense_amount_DR,
          expense_amount_CR: expense_amount_CR,
          balance: balance
        })
    }

    setTimeout(() => {
      var content = $("#print-sectionAccount").prop('outerHTML');
      var printWindow = window.open('', '', '');
      printWindow.document.write('<html><head><title>Print</title>');
      var _link = $('link');
      var _style = $('style');
      var strstyle = '';
      var _script = $('script');
      for (var k = 0; k < _link.length; k++)
        printWindow.document.write(_link[k].outerHTML);
      for (var i = 0; i < _style.length; i++)
        printWindow.document.write(_style[i].outerHTML);
      for (var j = 0; j < _script.length; j++)
        printWindow.document.write(_script[j].outerHTML);
      printWindow.document.write('</head><body  style="-webkit-print-color-adjust: exact;     margin-top: 1px;"  >');
      printWindow.document.write(content);
      printWindow.document.write('<script> $(".AES").css("display", "block");</script> </body ></html>');
      printWindow.document.close();

    }, 1000)

  }







  getLabels() {
    this.UtilityService.getLabels('expense-list', this.global.lang)
      .subscribe(response => {
        if (response) {
          this.ArrLabels = response;
          this.setLabels();
          console.log(this.ArrLabels);
        }
      },
        error => console.log(error))
  }

  setLabels() {
    //title
    this.labels['expense_list_title'] = this.ArrLabels.find((o: any) => o.key === 'expense_list_title').value;

    // filter lables
    this.labels['GL_Master'] = this.ArrLabels.find((o: any) => o.key === 'GL_Master').value;
    this.labels['GL_Child'] = this.ArrLabels.find((o: any) => o.key === 'GL_Child').value;
    this.labels['fromDate'] = this.ArrLabels.find((o: any) => o.key === 'fromDate').value;
    this.labels['toDate'] = this.ArrLabels.find((o: any) => o.key === 'toDate').value;

    // grid labels
    this.labels['expense_value_dt'] = this.ArrLabels.find((o: any) => o.key === 'expense_value_dt').value;
    this.labels['expense_documentNo'] = this.ArrLabels.find((o: any) => o.key === 'expense_documentNo').value;
    this.labels['expense_remarks'] = this.ArrLabels.find((o: any) => o.key === 'expense_remarks').value;
    this.labels['expense_amount'] = this.ArrLabels.find((o: any) => o.key === 'expense_amount').value;
    this.labels['expense_GL_CR'] = this.ArrLabels.find((o: any) => o.key === 'expense_GL_CR').value;
    this.labels['expense_GL_DR'] = this.ArrLabels.find((o: any) => o.key === 'expense_GL_DR').value;


  }
}



// WEBPACK FOOTER //
// ./src/app/components/management/expense-list/expense-list.component.ts